import purify from './purify'

export default function click(url, targetBlank) {
  if (!window.location.origin) {
    console.error('link-click::click disabled: no "origin" property ' +
      'found in window.location or property empty')
    return false
  }
  var pagePrefix = window.location.origin + ctx
  var _a = document.createElement('a')
  _a.href = url
  if (_a.protocol !== 'http:' && _a.protocol !== 'https:') {
    console.warn('link-click::the protocol of url: ' + url + ' is not permitted')
    return false
  }
  if (targetBlank) {
    _a.target = '_blank'
  }
  var clean = purify.run(_a, {
    FORCE_BODY: false,
    IN_PLACE: true,
    ALLOW_TARGET_IF_REL: false,
    ALLOW_TARGET_IF_LOCAL: true,
  })
  var _href = clean.href
  if (_href && _href.indexOf(pagePrefix) === 0 &&
    (pagePrefix.length === _href.length || _href[pagePrefix.length] === '/')) {
    console.log('link-click::redirecting to: ' + clean)
    clean.click()
    return true
  }
  console.warn('link-click::url: ' + url + ' is not permitted')
  return false
}
